import thunk from 'redux-thunk';
import {createStore,combineReducers,applyMiddleware} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension'
import { cartReducer, countReducer } from './Component/redux/reducres/cartReducers';
import { userDetailsReducer, userReducers, userRegisterReducer } from './Component/redux/reducres/userReducres';



const reducer=combineReducers({
    cart:cartReducer,
    count:countReducer,
    userLogin:userReducers,
    userRegister:userRegisterReducer,
    userDetails:userDetailsReducer,
})

const cartItemsfromStorage=localStorage.getItem('cartItems') ?
    JSON.parse(localStorage.getItem('cartItems')) : []

const userInfofromStorage=localStorage.getItem('userInfo') ?
    JSON.parse(localStorage.getItem('userInfo')) : null


const initialState={
    cart:{cartItems : cartItemsfromStorage},
    userLogin:{userInfo:userInfofromStorage}
}

const middleware=[thunk]

const store=createStore(reducer, initialState,
    composeWithDevTools(applyMiddleware(...middleware)))

export default store;